function convertMonthToDay(num) {
  let eq = "Converting " + num + " month to day: \n" +
    num + " * 30.436875 = ";
  let rep = num * 30.436875;
  return eq + rep.toFixed(3);
}

function convertMonthToHour(num) {
  let eq =
    "Converting " +
    num +
    " month to hour: \n" +
    num +
    " * 730.485 = ";
  let rep = num * 730.485;
  return eq + rep.toFixed(3);
}

function convertMonthToMinute(num) {
  let eq =
    "Converting " +
    num +
    " month to minute: \n" +
    num +
    " * 43829.1 = ";
  let rep = num * 43829.1;
  return eq + rep.toFixed(3);
}

function convertMonthToSecond(num) {
  let eq =
    "Converting " +
    num +
    " month to second: \n" +
    num +
    " * 2629746 = ";
  let rep = num * 2629746;
  return eq + rep.toFixed(2);
}

function convertMonthToWeek(num) {
  let eq =
    "Converting " +
    num +
    " month to week: \n" +
    num +
    " * 4.348125 = ";
  let rep = num * 4.348125;
  return eq + rep.toFixed(3);
}

function convertMonthToYear(num) {
  let eq =
    "Converting " +
    num +
    " month to year: \n" +
    num +
    " * 0.08333333333333333 = ";
  let rep = num * 0.08333333333333333;
  return eq + rep.toFixed(4);
}

export {
  convertMonthToYear,
  convertMonthToWeek,
  convertMonthToSecond,
  convertMonthToMinute,
  convertMonthToHour,
  convertMonthToDay
};
